import { FC } from 'react';

export interface PaginationFooterProps {
  /** 현재 페이지 — clamp된 safePage를 넘길 것 (필터 변경으로 pageCount가 줄어도 안전) */
  page: number;
  pageCount: number;
  onPage: (page: number) => void;
}

/**
 * 이전/다음 페이지네이션 — 쿠폰 정산 모달 공용 (표시용, 검색 결과 기준).
 * 1페이지뿐이면 아무것도 그리지 않는다 (기존 `length > PAGE_SIZE` 게이트와 동일).
 */
export const PaginationFooter: FC<PaginationFooterProps> = ({
  page,
  pageCount,
  onPage,
}) => {
  if (pageCount <= 1) return null;
  return (
    <div className="mt-4 flex items-center justify-center gap-3 text-sm">
      <button
        onClick={() => onPage(Math.max(1, page - 1))}
        disabled={page <= 1}
        className="rounded border border-gray-300 px-3 py-1 text-gray-600 hover:bg-gray-50 disabled:opacity-40"
      >
        이전
      </button>
      <span className="tabular-nums text-gray-500">
        {page} / {pageCount}
      </span>
      <button
        onClick={() => onPage(Math.min(pageCount, page + 1))}
        disabled={page >= pageCount}
        className="rounded border border-gray-300 px-3 py-1 text-gray-600 hover:bg-gray-50 disabled:opacity-40"
      >
        다음
      </button>
    </div>
  );
};
